/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { i } from './i';
export type BookingRefundDto = {
    /**
     * Refund UUID
     */
    id: string;
    /**
     * Refund amount
     */
    refundAmount: i;
    /**
     * Refund status
     */
    status: BookingRefundDto.status;
    /**
     * Approved at
     */
    approvedAt?: Record<string, any>;
};
export namespace BookingRefundDto {
    /**
     * Refund status
     */
    export enum status {
        PENDING = 'pending',
        APPROVED = 'approved',
        DECLINED = 'declined',
        PROCESSED = 'processed',
        FAILED = 'failed',
    }
}

